import React from 'react';
import ardowenLogo from '../assets/ardowen-logo.png';

/**
 * A small, discreet Ardowen branding mark anchored to the bottom-right of the
 * screen (issue #41). Deliberately low-opacity and `pointer-events-none` so it
 * never sits over, or interferes with, the screen's interactive controls
 * (search / pass-fail). Decorative only — not a link or a control.
 */
export function ArdowenLogo(): React.JSX.Element {
  return (
    <img
      src={ardowenLogo}
      alt="Ardowen"
      className="fixed bottom-4 right-4 z-10 h-16 w-auto opacity-30 pointer-events-none select-none"
    />
  );
}
